export const planSelector = state => state.app.org.plan;
